export type V2FallbackDestination =
  | 'home'
  | 'organization'
  | 'instance'
  | 'instanceCreate'
  | 'infrastructure'
  | 'pulsarCluster'
  | 'pulsarClusterDetails'
  | 'kafkaCluster'
  | 'kafkaClusterDetails'
  | 'workspace'
  | 'workspaceConnections'
  | 'agents'
  | 'agent'
  | 'tenant'
  | 'namespace'
  | 'topic'
  | 'kafkaTopic'
  | 'connector'
  | 'function'
  | 'universalLink'
  | 'universalLinks'

export type V2ConsoleTarget =
  | { path: string; match: 'exact' }
  | {
      path: string
      match: 'fallback'
      fallbackDestination: V2FallbackDestination
    }

export type V2ConsoleRouteContext = {
  routeName?: string | null
  params?: Record<string, unknown>
  query?: Record<string, unknown>
  pulsarClusterName?: string
  kafkaClusterName?: string
  workspaceName?: string
  topicPersistent?: boolean
}

export const readString = (
  record: Record<string, unknown> | undefined,
  key: string
): string | undefined => {
  const value = record?.[key]
  if (typeof value === 'string' && value.length > 0) return value
  if (Array.isArray(value) && value.length === 1) {
    const [onlyValue] = value
    return typeof onlyValue === 'string' && onlyValue.length > 0 ? onlyValue : undefined
  }
  return undefined
}

export const segment = (value: string): string => encodeURIComponent(value)

export const exact = (path: string): V2ConsoleTarget => ({ path, match: 'exact' })

export const fallback = (
  path: string,
  fallbackDestination: V2FallbackDestination
): V2ConsoleTarget => ({
  path,
  match: 'fallback',
  fallbackDestination
})
